// we are going to use react-tabs
import * as ReactTabs from "react-tabs";
import "./Tabs.scss";

/**
 * <CustomTab />
 *
 * This is a custom wrapper for <Tab />
 * We need this in order to RESET the scrollTop of "main-content"
 * every time tab is switched.
 *
 * @parent <Tabs />
 * @stateless
 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Transition from 'components/UI/Transition';

const DEFAULT_CLASS = 'react-tabs__tab';

const { Tab: OriginalTab, TabPanel: OriginalTabPanel } = ReactTabs

class CustomTab extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  //
  // when a new tab was selected which means selected == false,
  // we make scrollTop of main-section to 0
  //
  onClick() {
    let {
      selected,
      scrollMainSectionToTop = true,
    } = this.props;

    if (!selected && scrollMainSectionToTop) {
      // global["--classtop-main-section"].scrollTop = 0;
    }
  }

  render() {

    return (
      <OriginalTab {...this.props} onClick={this.onClick}/>
    );
  }
}

CustomTab.tabsRole = 'Tab';

class CustomTabPanel extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    //
    // it seems like TabPanel doesn't really pass className
    //
    return (
      <OriginalTabPanel {...this.props} >
        <div className='tab-panel-content'>
          {this.props.children}
        </div>
      </OriginalTabPanel>
    );
  }
}

CustomTabPanel.tabsRole = 'TabPanel';


export default {
  ...ReactTabs,
  Tab: CustomTab,
  TabPanel: CustomTabPanel,
}



// WEBPACK FOOTER //
// ./src/components/UI/Tabs/index.js